/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_ActionsInputs */

const en_ui_studio_actions = /** @type {(inputs: Ui_Studio_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Route actions`)
};

const de_ui_studio_actions = /** @type {(inputs: Ui_Studio_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen für Route`)
};

/**
* | output |
* | --- |
* | "Route actions" |
*
* @param {Ui_Studio_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_actions = /** @type {((inputs?: Ui_Studio_ActionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_ActionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_actions(inputs)
	return de_ui_studio_actions(inputs)
});